import * as React from "react";

export type HtmlTagProps = Omit<React.HTMLProps<any>, "ref"> & {
  html?: string;
  tag?: string;

  children?: any;
};

const HtmlTag = React.forwardRef((props: HtmlTagProps, ref: React.RefObject<any>) => {
  const { tag, html, children, ...tagProps } = props;
  const Tag = (tag ?? "div") as unknown as React.ComponentType<React.HTMLProps<any>>;

  return (
    <Tag ref={ref} {...tagProps} dangerouslySetInnerHTML={html ? { __html: html } : undefined}>
      {children}
    </Tag>
  );
});

export default HtmlTag;
